<template>
  <div
    class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter"
    id="page-login"
  >
    <div class="m-0 vx-col">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="items-center justify-center vx-row no-gutter">
            <div class="vx-col d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="mb-16 vx-card__title" style="width: 45vh;">
                  <img src="@/assets/images/logo/logo.png" class="mx-auto" style="max-width: 35vh;" />
                </div>
                <div>
                  <ValidationObserver v-slot="{ invalid }">
                    <ValidationProvider
                      passes
                      name="email address"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        label-placeholder="Email address"
                        v-model="email"
                        class="w-full"
                        :success="errors.length === 0"
                        success-text="Email address is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      vid="confirm"
                      passes
                      name="new-password"
                      rules="required|min:6|max:30"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="new-password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="New Password"
                        v-model="new_password"
                        class="w-full mt-6"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      passes
                      name="new-password-confirm"
                      rules="required|min:6|max:30|confirmed:confirm"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="new-password-confirm"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="New Password Confirm"
                        v-model="new_password_confirm"
                        class="w-full mt-6"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <VueRecaptcha
                      :sitekey="site_key"
                      ref="invisibleRecaptcha"
                      @verify="changePassword"
                      size="invisible"
                      :loadRecaptchaScript="true"
                    >
                    </VueRecaptcha>
                    <vs-alert :active="isError" class="mt-2" color="danger" icon="new_releases">
                      <span>{{error_message}}</span>
                    </vs-alert>
                    <router-link :to="{name: 'login'}">
                      <vs-button type="border" class="mt-8">Back</vs-button>
                    </router-link>
                    <vs-button
                      class="float-right mt-8"
                      :disabled="invalid || email === ''"
                      @click.prevent="$refs.invisibleRecaptcha.execute()"
                    >Change Password</vs-button>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      email: '',
      new_password: '',
      new_password_confirm: '',
      isError: false,
      error_message: '',
      site_key: process.env.VUE_APP_CAPTCHA_PUBLIC,
    }
  },
  methods: {
    async changePassword(token) {
      this.isError = false;
      this.error_message = "";
      this.$http
        .post('/user/change-password', { "g-recaptcha-response": token, email: this.email, password: this.new_password, password_confirmation: this.new_password_confirm, password_reset_id: this.$route.params.id })
        .then(res => {
          if (res.data && res.data.status === true) {
            this.$swal({
              icon: 'success',
              title: "Successful",
              text: res.data.message,
              showConfirmButton: true
            })
            this.$router.push('/login');
          }
        })
        .catch(err => {
          this.isError = true
          this.error_message = err.response.data.message
        })
    }
  },
  created(){
    clearInterval(localStorage.notifier);
  }
}
</script>
